// extracted by mini-css-extract-plugin
module.exports = {"HeroEditorial":"styles_HeroEditorial__WNu0q","title":"styles_title__uGkH8","chapo":"styles_chapo__mfXep"};